<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Edit Customer</h2>
  </div>
  <app-customer-form
    [form]="form"
    [initialSelectedCompanies]="initialSelectedCompanies"
    [initialIpRanges]="initialIpRanges"
    submitButtonText="Update Customer"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-customer-form>
</div>
